const dashboardReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_DASHBOARD_SUCCESS":
      return action.payload
    default:
      return state
  }
}

export default dashboardReducer
